if (!customElements.get('sticky-button')) {
  class StickyButton extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('exo:add-to-cart-click'));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('sticky-button', StickyButton);
}
